import type { Placement } from '@popperjs/core';
import styled, { css, keyframes } from 'styled-components';

import { DisplayDownIcon, SuccessIcon } from '@genially/icons';

import style from '../../../style';
import BaseInput from '../BaseInput/BaseInput';
import type { Status } from '../types';
import { StyledInput } from '../Common.styled';

interface StyledRightIconProps {
  $showList: boolean;
  $hasAnimation: boolean;
  $status?: Status.DEFAULT | Status.ERROR;
  $disabled?: boolean;
  $listPlacement?: Placement;
}

interface StyledBaseInputProps {
  $disabled?: boolean;
}

const iconRotateIn = () =>
  keyframes({
    '0%': {
      transform: `rotate(0deg)`,
    },
    '100%': {
      transform: 'rotate(180deg)',
    },
  });

const iconRotateOut = () =>
  keyframes({
    '0%': {
      transform: `rotate(180deg)`,
    },
    '100%': {
      transform: 'rotate(0deg)',
    },
  });

const getIconRotation = (showList: boolean, listPlacement?: Placement) => {
  if (listPlacement && listPlacement === 'top') {
    return showList ? iconRotateOut : iconRotateIn;
  }

  return showList ? iconRotateIn : iconRotateOut;
};

export const StyledRightIcon = styled(DisplayDownIcon)<StyledRightIconProps>(
  ({ $disabled }) => ({
    cursor: $disabled ? 'not-allowed' : 'pointer',
  }),
  () =>
    ({ $showList, $hasAnimation, $listPlacement }) => css`
      animation: ${getIconRotation($showList, $listPlacement)} ${$hasAnimation ? 0.2 : 0}s
        cubic-bezier(0.4, 0, 0.4, 1) forwards;
    `,
);

export const ListWrapper = styled.div(() => ({}));

export const Wrapper = styled.div<StyledBaseInputProps>(({ $disabled }) => ({
  position: 'relative' as const,
  width: '100%',
  cursor: $disabled ? 'not-allowed' : 'pointer',
}));

export const StyledSuccessIcon = styled(SuccessIcon)(({ theme: { color } }) => ({
  ...style.mixins.increaseSpecificity(
    {
      color: color.content.accent.default(),
    },
    5,
  ),
}));

export const BaseInputWrapper = styled.div(() => ({
  width: '100%',
}));

export const StyledBaseInput = styled(BaseInput)<StyledBaseInputProps>(
  ({ $disabled }) => ({
    [StyledInput]: {
      cursor: $disabled ? 'not-allowed' : 'pointer',
    },
  }),
);
